import moment from 'moment';

import { getScheduleGap } from '../../../api/ClientFillScheduleGap/ClientFillScheduleGap';

import { timeToSlot } from '../../../modules/timeSlotUtils';
import type { IRootDispatch } from '../../../store/models';

import {
  FillScheduleGapPageModelState,
  FillScheduleGapPageModelScheduleGap,
  OnEnterFlowSuccessPayload,
} from './FillScheduleGap.types';

const fillScheduleGapPage = {
  name: 'fillScheduleGapPage' as string,

  state: {
    datePreselected: false,
    scheduleGap: {},
    toasterPreviouslyShown: false,
  } as FillScheduleGapPageModelState,

  reducers: {
    onDatePreselected: (state: FillScheduleGapPageModelState) => ({
      ...state,
      datePreselected: true,
    }),
    onEnterFlowSuccess:
      (state: FillScheduleGapPageModelState, payload: OnEnterFlowSuccessPayload) => ({
        ...state,
        ...payload,
        tokenValid: true,
      }),
    onEnterFlowFailed:
      (state: FillScheduleGapPageModelState) => ({
        ...state,
        tokenValid: false,
      }),
    onToasterShownSuccess: (state: FillScheduleGapPageModelState) => ({
      ...state,
      toasterPreviouslyShown: true,
    }),
  },

  effects: (dispatch: IRootDispatch) => ({
    land: async ({
      token,
    }: {
      token: string,
    }): Promise<void> => {
      try {
        const {
          appointment,
          client,
          schedule_gap,
          service,
          source,
        } = await getScheduleGap(token);

        if (!schedule_gap) {
          throw new Error('Token is missing required data');
        }

        const { id, provider, recommended_client_appointment } = schedule_gap;
        const { local_start: localStart } = schedule_gap;
        const { gap_still_open: isAvailable } = schedule_gap;

        dispatch.fillScheduleGapPage.onEnterFlowSuccess({
          scheduleGap: {
            appointment,
            client,
            formattedDate: moment(localStart).format('YYYY-MM-DD'),
            id,
            isAvailable,
            localStart,
            provider,
            recommendedClientAppointment: recommended_client_appointment,
            service,
            source,
            slot: timeToSlot(moment(localStart)),
            time: moment(localStart).format('hh:mm a'),
          },
        });
      } catch (err) {
        dispatch.fillScheduleGapPage.onEnterFlowFailed();
      }
    },
  }),

  selectors: (slice: any, createSelector: any) => ({
    getTokenValid: () => createSelector(
      slice,
      ((state: FillScheduleGapPageModelState): boolean => state.tokenValid),
    ),
    getScheduleGap: () => createSelector(
      slice,
      ((state: FillScheduleGapPageModelState):
      FillScheduleGapPageModelScheduleGap => state.scheduleGap),
    ),
    getDatePreselected: () => createSelector(
      slice,
      ((state: FillScheduleGapPageModelState): boolean => state.datePreselected),
    ),
    showToaster: () => createSelector(
      slice,
      ((state: FillScheduleGapPageModelState): boolean => (
        typeof state.scheduleGap?.isAvailable === 'boolean'
        && !state.toasterPreviouslyShown
      )),
    ),
  }),
};

export default fillScheduleGapPage;
